import { render, staticRenderFns } from "./CreateOrUpdateTestsForm.vue?vue&type=template&id=059b1f3c&"
import script from "./CreateOrUpdateTestsForm.vue?vue&type=script&lang=js&"
export * from "./CreateOrUpdateTestsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports